module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Thunder-circle-aa54a74b74800c0b1b4385beeae54566.svg";